import { useGetBasename } from 'hooks/useGetBasename/useGetBasename';
import { useCallback } from 'react';

/**
 * Hook that returns a callback function to generate absolute URLs.
 * The callback combines the current domain, router basename, and provided path
 * to create complete URLs suitable for sharing or external links.
 *
 * @returns A callback function that takes a path and returns the full absolute URL
 * @example
 * const getAbsoluteUrl = useAbsoluteUrl();
 * const shareUrl = getAbsoluteUrl('/browse'); // Returns: "https://example.com/browse"
 */
export const useAbsoluteUrl = (): ((path: string) => string) => {
    const basename = useGetBasename();

    const getAbsoluteUrl = useCallback(
        (path: string) => {
            const sanitizedPath = path === '/' ? '' : path;

            return `${window.location.origin}${basename}${sanitizedPath}`;
        },
        [basename],
    );

    return getAbsoluteUrl;
};
